<h2 mat-dialog-title>
  @if (data.icon) {
    <fa-icon matPrefix [icon]="data.icon" size="xl" class="icon"></fa-icon>
  } @else if (data.type === 'delete') {
    <fa-icon matPrefix [icon]="['fas', 'trash']" size="xl" class="icon" id="trash"></fa-icon>
  }
  {{ data.title || 'Confirmation' }}
</h2>
@if (data.subTitle) {
  <p class="subtitle">{{ data.subTitle }}</p>
}
<mat-dialog-content>
  @for (paragraph of data.paragraphs; track $index) {
    <p>{{ paragraph }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button
    matButton="outlined"
    class="close-button"
    [class.app-btn-destructive]="data.type === 'delete'"
    (click)="confirm()"
  >
    {{ data.primaryButtonText || 'Confirm' }}
  </button>
  <button matButton="elevated" (click)="close()">
    {{ data.secondaryButtonText || 'Close' }}
  </button>
</mat-dialog-actions>
